export const MODIFY_SELECTED_TEAM = 'MODIFY_SELECTED_TEAM';

export function modifySelectedTeam(selectedTeamIdx){
    return{
        type: MODIFY_SELECTED_TEAM,
        mainState: {
            selectedTeamIdx: selectedTeamIdx
        }
    }
}